import * as ActionTypes from "../../Actions/DriverManagement/ActionTypes";

export const clearStateMNGAction = (stateName) => {
    return { type: ActionTypes.CLEAR_STATE_DRIVERMNG, stateName };
};


export const creacteDriverWithfileAction = (data, DriverOrDistributor) => {
    return { type: ActionTypes.CREATE_DRIVER_WITH_FILE, data, DriverOrDistributor };
};
export const creacteDriverWithfileSuccessAction = (res) => {
    return { type: ActionTypes.CREATE_DRIVER_WITH_FILE_SUCCESS, res };
};
export const creacteDriverWithfileFailAction = () => {
    return { type: ActionTypes.CREATE_DRIVER_WITH_FILE_FAIL };
};


export const deleteDriverAction = (id) => {
    return { type: ActionTypes.DELETE_DRIVER, id };
};
export const deleteDriverSuccessAction = (res) => {
    return { type: ActionTypes.DELETE_DRIVER_SUCCESS, res };
};
export const deleteDriverFailAction = (error) => {
    return { type: ActionTypes.DELETE_DRIVER_FAIL, error };
};


export const editDriverAction = (data) => {
    return { type: ActionTypes.EDIT_DRIVER, data }
};
export const editDriverSuccessAction = (res) => {
    return { type: ActionTypes.EDIT_DRIVER_SUCCESS, res }
};
export const editDriverFailAction = (error) => {
    return { type: ActionTypes.EDIT_DRIVER_FAIL, error }
};


export const changeDriverPasswordAction = (data) => {
    return { type: ActionTypes.CHANGE_DRIVER_PASSWORD, data }
};
export const changeDriverPasswordSuccessAction = (res) => {
    return { type: ActionTypes.CHANGE_DRIVER_PASSWORD_SUCCESS, res }
};
export const changeDriverPasswordFailAction = (error) => {
    return { type: ActionTypes.CHANGE_DRIVER_PASSWORD_FAIL, error }
};


export const createDriverWithVehicleAction = (data) => {
    return { type: ActionTypes.CREATE_DRIVER_WITH_VEHICLE, data };
};
export const createDriverWithVehicleSuccessAction = (res) => {
    return { type: ActionTypes.CREATE_DRIVER_WITH_VEHICLE_SUCCESS, res };
};
export const createDriverWithVehicleFailAction = (error) => {
    return { type: ActionTypes.CREATE_DRIVER_WITH_VEHICLE_FAIL, error };
};


export const getDriverAction = (driverData) => {
    return { type: ActionTypes.GET_DRIVER, driverData };
};
export const getDriverSuccessAction = (res) => {
    return { type: ActionTypes.GET_DRIVER_SUCCESS, res };
};
export const getDriverFailAction = (error) => {
    return { type: ActionTypes.GET_DRIVER_FAIL, error };
};

export const getAllDriversOfPlanAction = (data) => {
  return { type: ActionTypes.GET_ALL_DRIVER_OF_PLAN, data };
};
export const getAllDriversOfPlanSuccessAction = (res) => {
  return { type: ActionTypes.GET_ALL_DRIVER_OF_PLAN_SUCCESS, res };
};
export const getAllDriversOfPlanFailAction = (error) => {
  return { type: ActionTypes.GET_ALL_DRIVER_OF_PLAN_FAIL, error };
};


export const searchTenantDriversAction = (vehicleParam) => {
    return { type: ActionTypes.SEARCH_TENANT_DRIVERS, vehicleParam };
};
export const searchTenantDriversSuccessAction = (res) => {
    return { type: ActionTypes.SEARCH_TENANT_DRIVERS_SUCCESS, res };
};
export const searchTenantDriversFailAction = (error) => {
    return { type: ActionTypes.SEARCH_TENANT_DRIVERS_FAIL, error };
};


export const searchTenantDriverPersonalAction = (query) => {
    return { type: ActionTypes.SEARCH_TENANT_DRIVER_PERSONAL, query };
};
export const searchTenantDriverPersonalSuccessAction = (res) => {
    return { type: ActionTypes.SEARCH_TENANT_DRIVER_PERSONAL_SUCCESS, res };
};
export const searchTenantDriverPersonalFailAction = (error) => {
    return { type: ActionTypes.SEARCH_TENANT_DRIVER_PERSONAL_FAIL, error };
};


//DISPATCHTOFRIVE
export const postDriverInfoAction = (data) => {
    return { type: ActionTypes.POST_DRIVER_INFO, data };
};
export const postDriverInfoSuccessAction = (res) => {
    return { type: ActionTypes.POST_DRIVER_INFO_SUCCESS, res };
};
export const postDriverInfoFailAction = (error) => {
    return { type: ActionTypes.POST_DRIVER_INFO_FAIL, error };
};



export const activeMissionToDriverAction = (data) => {
    return { type: ActionTypes.ACTIVE_MISSION_TO_DRIVER, data };
};
export const activeMissionToDriveSuccessAction = (res) => {
    return { type: ActionTypes.ACTIVE_MISSION_TO_DRIVER_SUCCESS, res };
};
export const activeMissionToDriveFailAction = (error) => {
    return { type: ActionTypes.ACTIVE_MISSION_TO_DRIVER_FAIL, error };
};


export const DeleteMissionFromDriverAction = (data) => {
    return { type: ActionTypes.DELETE_MISSION_FROM_DRIVER, data };
};
export const DeleteMissionFromDriverSuccessAction = (res) => {
    return { type: ActionTypes.DELETE_MISSION_FROM_DRIVER_SUCCESS, res };
};
export const DeleteMissionFromDriverFailAction = (error) => {
    return { type: ActionTypes.DELETE_MISSION_FROM_DRIVER_FAIL, error };
};



export const CreateDistributorAction = (data) => {
    return { type: ActionTypes.CREATE_DISTRIBUTOR, data };
};
export const CreateDistributorSuccessAction = (res) => {
    return { type: ActionTypes.CREATE_DISTRIBUTOR_SUCCESS, res };
};
export const CreateDistributorFailAction = (error) => {
    return { type: ActionTypes.CREATE_DISTRIBUTOR_FAIL, error };
};

